import { Plane, TreePalm, Map } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const icons = [Plane, TreePalm, Map];
const images = [
  "https://images.unsplash.com/photo-1534756287545-6b3a471d4e0e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBibGFjayUyMHZhbiUyMHRyYW5zcG9ydHxlbnwwfHx8fDE3ODE3MjY4MTR8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1510414842594-a61c69b5ae57?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1518105779142-d975f22f1b0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
];

export const Services = () => {
  const { t } = useLang();
  return (
    <section id="services" className="py-20 md:py-32 bg-sand" data-testid="services-section">
      <div className="px-6 md:px-12 lg:px-20 mx-auto max-w-7xl">
        <div className="max-w-2xl mb-16">
          <p className="font-body text-xs tracking-[0.25em] uppercase text-teal font-bold mb-4">{t.services.overline}</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-jungle mb-5">{t.services.title}</h2>
          <p className="font-body text-jungle-light/80 leading-relaxed">{t.services.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {t.services.items.map((s, i) => {
            const Icon = icons[i];
            return (
              <div
                key={i}
                data-testid={`service-card-${i}`}
                className="group bg-white border border-border hover:-translate-y-1 hover:shadow-xl transition-all duration-300 overflow-hidden"
              >
                <div className="h-48 overflow-hidden">
                  <img src={images[i]} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-8">
                  <div className="w-12 h-12 bg-teal/10 flex items-center justify-center mb-5 -mt-14 relative z-10 border border-teal/20 backdrop-blur" style={{ background: "rgba(0,168,150,0.12)" }}>
                    <Icon size={22} className="text-teal" />
                  </div>
                  <h3 className="font-heading text-2xl font-semibold text-jungle mb-3">{s.title}</h3>
                  <p className="font-body text-sm text-jungle-light/80 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
